import React from "react";
import overviewHero from "../../assets/EMP_industriesoverview/overviewhero.webp";
import Overviewcards  from "../../Components/EmployersComponents/EMP_indusoverview/Overviewcards";
import GetStartedSection from "../../Components/EmployersComponents/EMP_indusoverview/GetStartedSection";
import Footer from "../../Components/Footer";



const EMP_indusoverview = () => {
  return (
    <section className="w-full bg-[white] overflow-hidden">
      <div
        className="
          max-w-[1400px]
          mx-auto
          px-5
          sm:px-8
          md:px-12
          lg:px-20
          py-14
          md:py-20
          mt-[100px]
          lg:mt-0
        "
      >
        <div
          className="
            flex
            flex-col
            lg:flex-row
            items-center
            justify-between
            gap-12
            lg:gap-20
          "
        >
          {/* LEFT CONTENT */}
          <div className="w-full lg:w-[48%] order-1  lg:mt-[100px] lg:-ml-[30px]">
            <p
              className="
                text-[16px]
                sm:text-[14px]
                md:text-[16px]
                md:tracking-normal
                lg:text-[14px]
                font-extrabold
                tracking-wide
                uppercase
                text-[#1b0a0a]
                mb-5
                sm:mt-80px
              "
            >
              Industries
            </p>

   <h1
  className="
    text-[#2c0606]

    font-normal
    lg:font-light

    leading-[1.05]

    text-[32px]
    sm:text-[52px]
    md:text-[38px]
    lg:text-[56px]

    max-w-[700px]
    md:-tracking-normal
    md:w-[600px]
  "
  style={{
    fontFamily:
      '"Cormorant Garamond", "Times New Roman", serif',
  }}
>
  We Serve Forward-
  <br className="hidden lg:block" />
  Thinking Employers
</h1>

            <p
              className="
                mt-7
                text-[#1f0606]
                text-[17px]
                sm:text-[18px]
                lg:text-[17px]
                leading-[1.5]
                lg:leading-[1.4]
                font-normal
                max-w-[640px]
                lg:w-[500px]

              "
              style={{
                fontFamily:
                  '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
              }}
            >
              While each industry has to deal with unique economic factors and
              different customer bases, there is one constant — their employees.
              Supporting employees with on-demand pay and other modern pay
              strategies can directly impact your business and lead to better
              customer service, patient care, and anything in between.
            </p>

            <p
              className="
                mt-7
                text-[#1f0606]
                text-[17px]
                sm:text-[18px]
                lg:text-[17px]
                leading-[1.5]
                lg:leading-[1.4]
                font-normal
                max-w-[640px]
                lg:w-[500px]
              "
              style={{
                fontFamily:
                  '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
              }}
            >
              Empowering employees with on-demand pay gives them greater
              financial control and makes them feel more supported. If your
              employees are happier in their roles, your company can see
              improved retention, higher engagement, and more — all leading to
              better business outcomes.
            </p>

          <button
  className="
    mt-10
    mx-auto
    lg:mx-0
    block
    bg-[#1d0303]
    hover:bg-[#2f0202]
    transition-all
    duration-300
    text-white
    px-6
    sm:px-8
    sm:py-2
    py-2
    lg:px-5
    lg:py-2
    text-[16px]
    lg:text-[18px]
    font-bold
    shadow-md
     
  "
>
  Let’s Talk
</button>
          </div>

{/* RIGHT IMAGE */}
<div
  className="
    w-full
    lg:w-[52%]
    order-2
    mt-[50px]
    lg:mt-10

    h-[300px]
    sm:h-[420px]
    md:h-[500px]
    lg:h-auto

    flex
    justify-center
    items-center

    sm:px-0
  "
>
  <div
    className="
      w-full
      max-w-[760px]
      lg:w-[600px]

      h-full
      lg:h-[400px]

      overflow-hidden

      rounded-[32px]
      sm:rounded-[40px]
      lg:rounded-[50px]
    "
  >
    <img
      src={overviewHero}
      alt="Industries Overview"
      className="
        w-full
        lg:h-full
        object-cover
        object-center
        block
      "
    />
  </div>
</div>
        </div>
      </div>
      <Overviewcards />
      <GetStartedSection />
      <Footer />
    </section>
  );
};

export default EMP_indusoverview;